(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7057],{

/***/ 13266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/depop-competitors/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2021-10-21",
      tag: "Depop",
      title: "7 Marketplaces Like Depop - 2021",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "\"Depop is the most used app for online selling. And with the whole e-commerce world keeping up with the trend, many other marketplace competitors are picking up with their popularity. Find out here what other fashion resale sites are out there where you can list your items and reach more potential buyers.\""
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "With over 30 million registered users worldwide, Depop has become the mostly-used app for online selling. Beyond e-commerce, Depop allows users to inspire and be inspired by the communities around them. This is why they approach their website and mobile app with a modern and minimalist design, making it an appealing and user-friendly fashion marketplace for both buyers and sellers."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Depop has become a subsidiary of Etsy, but they still have several strong competitors in the market. If you are looking for alternatives to Depop, here is a short guide on other best apps for online selling."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Mercari"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Originally from Japan, Mercari has gained popularity worldwide as a site to buy and sell vintage fashion and other handmade products. Formerly known as Kouzoh, Inc, the app was founded by Shinto Yamada, a Japanese entrepreneur, in February 2013. A year after its original release, the app had accumulated over a million individual listings on its platform. As of this writing, more than 50 million people have downloaded this app, and more than 350 thousand new individual listings daily. Mercari is averaging a 4.8 rating in the App store and a 4.5 rating through Google Play."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Not only is Mercari led by an exceptional team, but Mercari also makes it a point to continuously improve its services and take advantage of emerging technologies by employing the world\u2019s ingenious thinkers. Technology teams are in Japan, California, and Massachusetts. The company also take pride with their affiliations with top research universities in the United States and Japan."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Kidzen"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The majority of the apps for buying and selling used clothing and other items are focused on adults. It is seldom one finds an app catering to children\u2019s clothes and accessories. Thankfully, Kidzen is the answer to such a problem!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Kidizen was established in 2013, with Itizen as its original name. After a year, they launched their iOS app under Kidizen. They have been around for quite a while now, but few people know about this app. It has evolved from focusing solely on kids to including a Mama category\u2014 where one can now sell women\u2019s clothes and accessories."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Tradesy"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "It is a thrift resale market that focuses on designer clothing for women. The brands available include Chanel, Hermes, Prada, and Off-White, to name a few. However, they also have streetwear like Urban Outfitters and Nike. Founded and launched in 2012, total funding is currently at $133.7M with 15 investors. It is ranked 24,586 among websites globally based on their monthly web visitors of 2.1Million"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "One perk of selling through this website is that sellers get a free shipping kit whenever their item sells."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "ThredUp"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "What makes this resale platform ideal is ThredUp can post and market your clothes for you. You only have to fill in the bag they will send you and deliver it back to them. If these items are still part of the latest trends, they pay you right away."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "They also have the Donation Program, where you can send unsold items. In turn, they will give a $5 donation to your preferred charity. This is why you have to make sure your offerings are still in good condition, especially those who will receive them for free."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Take note, however, that your cut for your sales can be as low as 5%. For instance, $15 worth of items gives the seller 5%, while items costing about $300 make you 80%. The commission varies depending on your prices."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Poshmark"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Like Depop, Poshmark is another app to sell old clothes or items one no longer uses. It is the online shopping destination of people who share a love of fashion, especially millennials and Gen-Z. It is similar to Pinterest with its focus on beautiful photos and modern app and web design."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Poshmark also aims to empower business-minded people to become the next generation of retailers. Currently, they have more than 60 million users worldwide. In the last 30 days alone, there were 1.3 million downloads or a monthly download growth of 9.29% of this app.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "eBay"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Considered as an excellent alternative to Depop, eBay is a dependable marketplace. With more than a 180Million active buyers, the chances of a seller selling their products are high. There are millions of visitors who go to this website every day."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["One excellent feature of this site is that it shows a \u201Csold\u201D listing. Unfortunately, Depop doesn\u2019t have this. It is easy then to monitor what you have sold for the last 60 days. There is also a \u201Cbest offer\u201D button which allows the customers to send offers. Depop, on the other hand, sends offers via direct messages.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Founded in 1995, eBay may be the pioneer in the online marketplace. As of 2020, revenues are at $10.27 billion and are also listed in NASDAQ. eBay boasts of 1.5 billion live listings, 159 million active buyers worldwide, and 19 million sellers in its marketplace."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Facebook Marketplace"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Whether one is a buyer or a seller, what people are searching for in terms of e-commerce are convenience and accessibility. Fortunately, there is the internet and the widely-used social networking site, Facebook, to connect people. As long as one has Facebook, one can scroll through its marketplace to buy or sell clothing, accessories, decor, household essentials, vintage pieces, and a whole bunch of other items."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Transactions are easier not only because it is online, but users have the option to do meet-ups. After all, one can filter through the extensive offerings or inventory by using their location. Nearby sellers and buyers can easily connect even in cases of returns or refunds."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Take note, however, of scams and security issues. Unlike other shopping apps and websites, your Facebook account is indefinitely linked to the marketplace, which can compromise everything that you share from your personal life. As long as you are extra cautious in transacting, then everything else will go fine."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/depop-competitors.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "7 Marketplaces Like Depop - 2021"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Broaden your horizons and grow your resale business to multiple marketplaces!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/depop-competitors"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/depop-competitors"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "7 Marketplaces Like Depop - 2021"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "Broaden your horizons and grow your resale business to multiple marketplaces!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=4"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "2021-10-21T00:00:00.000Z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "2021-10-21T00:00:00.000Z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Depop"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 77826:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/depop-competitors",
      function () {
        return __webpack_require__(13266);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(77826); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);